const API_BASE = import.meta.env.VITE_API_BASE_URL || "";

export interface CompanyProfile {
  companyId: string;
  tradingName: string;
  legalName: string;
  companyType: string;
  industry: string;
  incorporationCountry: string;
  jurisdiction: string;
  email: string;
  phone: string;
  website: string;
  status: string;
  currency: string;
  registeredAddress: string;
  operatingAddress: string;
  businessNumber: string;
  foundingDate: string;
  incorporationDate: string;
  fiscalYearEnd: string;
  legalStatus: string;
  registrationStatus: string;
  notes: string;
}

export async function fetchCompanyProfile(): Promise<CompanyProfile> {
  const response = await fetch(`${API_BASE}/api/admin/company`);
  const body = await response.json();
  if (!response.ok || body.status === "error") {
    throw new Error(body?.error ?? `Request failed with ${response.status}`);
  }
  return body.data as CompanyProfile;
}

export async function saveCompanyProfile(profile: CompanyProfile): Promise<void> {
  const response = await fetch(`${API_BASE}/api/admin/company`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(profile),
  });
  const body = await response.json();
  if (!response.ok || body.status === "error") {
    throw new Error(body?.error ?? `Request failed with ${response.status}`);
  }
}
